import fly from '@/utils/http';
// 获取院内患者数据
export const queryPatientList = async (req = {}) => {
  const { rsp, err }: any = await fly.post('/hospital/queryPatientListNew', req);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};

// 获取院内分组
export const getGroup = async (req = {}) => {
  const { groups, err, count }: any = await fly.post('/hospital/InnerHospitalArchive/getGroup', req);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return { groups, count };
};

// 获取院外分组
export const querySearchGroupList = async (req = {}) => {
  const { rsp = {}, err }: any = await fly.post('/hospital/querySearchGroupList', req);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};

export const querySentGroupMsgDetails = async (req = {}) => {
  const { sentGroupMsgInfo = {}, err }: any = await fly.post('/hospital/querySentGroupMsgDetails', req);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return sentGroupMsgInfo;
};

export const getHospitalDepartmentList = async (req = {}) => {
  const { err, departmentList }: any = await fly.post('/hospital/getHospitalDepartmentList', req);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return { departmentList };
};

export const getPermDepartmentList = async (req = {}) => {
  const { err, departmentList }: any = await fly.post('/hospital/getPermDepartmentList', req);
  if (err) {
    throw new Error('弹窗拦截');
  }
  return { departmentList };
};
export const getInHospitalTagList = async () => {
  const { tagList, err } = (await fly.post('/hospital/getInHospitalTagList', {})) as any;
  if (err) {
    throw new Error('弹窗拦截');
  }
  return { tagList };
};
export const getInHospitalDoctorGroupList = async () => {
  const { doctorGroupList, err } = (await fly.post('/hospital/getInHospitalDoctorGroupList', {})) as any;
  if (err) {
    throw new Error('弹窗拦截');
  }
  return { doctorGroupList };
};
// 新增备注
export const apiAddPatientRemarks = async (req = {}) => {
  const { err }: any = await fly.post('/hospital/addPatientRemarks', req);
  if (err) {
    throw Error('弹窗拦截');
  }
};

// 删除备注
export const apiDeletePatientRemarks = async (req = {}) => {
  const { err }: any = await fly.post('/hospital/deletePatientRemarks', req);
  if (err) {
    throw Error('弹窗拦截');
  }
};

// 获取备注
export const getPatientRemarks = async (req = {}) => {
  const { err, remarksList = [] }: any = await fly.post('/hospital/getPatientRemarks', req);
  if (err) {
    throw Error('弹窗拦截');
  }
  return remarksList;
};

// 更新备注
export const updatePatientRemarks = async (req = {}) => {
  const { err }: any = await fly.post('/hospital/updatePatientRemarks', req);
  if (err) {
    throw Error('弹窗拦截');
  }
};

// 新增备注(欣悦)
export const apiAddPatientExternalFollowUp = async (req = {}) => {
  const { err }: any = await fly.post('/hospital/addPatientExternalFollowUp', req);
  if (err) {
    throw Error('弹窗拦截');
  }
};

// 删除备注
export const apiDeletePatientExternalFollowUp = async (req = {}) => {
  const { err }: any = await fly.post('/hospital/deletePatientExternalFollowUp', req);
  if (err) {
    throw Error('弹窗拦截');
  }
};

// 获取备注
export const getPatientExternalFollowUp = async (req = {}) => {
  const { err, list = [] }: any = await fly.post('/hospital/getPatientExternalFollowUp', req);
  if (err) {
    throw Error('弹窗拦截');
  }
  return list;
};

// 更新备注
export const updatePatientExternalFollowUp = async (req = {}) => {
  const { err }: any = await fly.post('/hospital/updatePatientExternalFollowUp', req);
  if (err) {
    throw Error('弹窗拦截');
  }
};

// 患者信息
export const queryPatientInfo = async (patientId: string) => {
  const { err, rsp }: any = await fly.post('/hospital/queryPatientInfo', {
    patientId,
  });
  if (err) {
    throw Error('弹窗拦截');
  }
  return rsp;
};

// 获取相应权限下的科室
export const apiGetSelfAllDepartmentList = async () => {
  const { err, departmentList }: any = await fly.post('/hospital/getSelfAllDepartmentList', {});
  if (err) {
    throw Error('弹窗拦截');
  }
  return { departmentList };
};

// 获取自定义标签组列表
export const apiGetCustomTagGroupList = async (req = {}) => {
  const { err, data = [], total }: any = await fly.post('/tag/getCustomTagGroupList', req);
  if (err) {
    throw new Error('弹窗拦截');
  }

  return {
    data,
    total,
  };
};

// 编辑患者疾病标签
export const apiUpdatePatientPortraitTag = async (req = {}) => {
  const { err, data = [] }: any = await fly.post('/tag/updatePatientPortraitTag', req);
  if (err) {
    throw new Error('弹窗拦截');
  }

  return {
    data,
  };
};

// 获取用户画像和标签
export const apiGetPatientPortraitTag = async (req = {}) => {
  const res: any = await fly.post('/tag/getPatientPortraitTag', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }

  return res;
};

// 更新消息发送状态
export const apiUpdateSentGroupMsg = async (req = {}) => {
  const { err }: any = await fly.post('/hospital/updateSentGroupMsg', req);
  if (err) {
    throw Error('弹窗拦截');
  }
  return;
};

// 获取电话号码
export const getOutCallPhone = async (patientId: string) => {
  const { err, rsp = {} }: any = await fly.post('/hospital/queryPatientPhone', {
    patientId,
  });
  if (err) {
    throw new Error('弹窗拦截');
  }
  return rsp;
};

// 批量获取患者画像标签信息（独立接口，用于异步加载标签类字段）
export const batchGetPatientPortraitTag = async (patientIds: string[]) => {
  const res: any = await fly.post('/tag/batchGetPatientPortraitTag', {
    patientIds,
  });
  return res;
};

// 获取所有权限的计划下所有管理师列表;
export const getPermissionManageList = async () => {
  const { err, data = [] }: any = await fly.post('/hospital/getAllPermissionedManagerList', {});
  if (err) {
    throw new Error('弹窗拦截');
  }
  return data;
};
